import { permissionTree, RESOURCE_SOLICITUDES } from '@/auth/permissions/modules/solicitudes'
import { ROUTE_APROBAR_SOLICITUD } from '@/router/routes/solicitudes/names'
import { defineMenu } from '@/utils/menu'

export default defineMenu([
    {
        title: 'solicitudes.subopciones.crear_solicitud',
        resource: RESOURCE_SOLICITUDES,
        action: permissionTree.transacciones.aprobarSolicitud,
        route: ROUTE_APROBAR_SOLICITUD,
    },
])
